export default __webpack_public_path__ + "static/media/expenses.bc4c07ad.svg";